import React from 'react';
import './NavItem.css';
import { NavLink } from "react-router-dom";
import { Dropdown } from '../dropdown/Dropdown';


export const NavItem = ({ link, name }) => {
    return (
        <div className="navItem">
            <NavLink
                exact
                to={link}
                activeClassName="active"
                className="nav-links"
            >
                {name}
            </NavLink>
        </div>
    )
};